<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
    navActiveLink: 'subjects',
  },
})

import { useScheduleStore } from "@/utils/stores/schedule"
import Answer from "@/views/subjectsV2/crf-answer/answer.vue"
import SelectAnswer from "@/views/subjectsV2/crf-answer/selectAnswer.vue"

const route = useRoute()
const router = useRouter()

const groupId = ref("0")
const cycleId = ref("0")
const visitId = ref("0")
const scheduleId = ref("0")
const nextScheduleId = ref("0")

scheduleId.value  = route.params.schedule

// select 에서 url 액션 모두 하고
// answer에서는 select된 결과만 받아서 처리 할수 있도록....

const onSelectedAnswer = (s, sId, nsId, status) => {
  groupId.value = s.gId+""
  cycleId.value = s.cId+""
  visitId.value = s.vId+""
  scheduleId.value = sId+""
  nextScheduleId.value = nsId+""

  useScheduleStore().setScheduleStatus(router.currentRoute.value.params.subject, status)

}

const refSelectAnswer = ref()

const saveAnswer = () => {
  refSelectAnswer.value.fetchDatas()
}

const onNext = nsId => {
  scheduleId.value = nextScheduleId.value
  refSelectAnswer.value.fetchDatas()
}
</script>

<template>
  <VRow>
    <VCol
      cols="12"
      md="3"
      style="max-inline-size:400px"
    >
      <SelectAnswer
        ref="refSelectAnswer"
        :schedule-id="scheduleId"
        @select-answer="onSelectedAnswer"
      />
    </VCol>
    <VCol
      cols="12"
      md="9"
    >
      <!-- on-save, on-next -->
      <Answer
        :group-id="groupId"
        :cycle-id="cycleId"
        :visit-id="visitId"
        :schedule-id="scheduleId"
        :next-schedule-id="nextScheduleId"
        @save-answer="saveAnswer"
        @on-next="onNext"
      />
    </VCol>
  </VRow>
</template>
